import Card from '@/components/Card';
import { Button } from '@/components/Button';
import { FieldValues } from 'react-hook-form';
import { FormManagementProps } from '@/type/form.types';
import {
  formatDateWithLetterMonth,
  getFormattedTime,
} from '@/utils/date.utils';
import { TitleSection } from '@/components/Header/Section/TitleSection';

export const RequestedAppUpdateInfosManagement = <TSchema extends FieldValues>({
  t,
  data,
  onSubmit,
}: FormManagementProps<TSchema>) => {
  return (
    <form onSubmit={onSubmit}>
      <Card
        title={
          <TitleSection
            text={t('common:request')}
            defaultIconClassName="-mt-0.75 ki-pad"
          />
        }
        bodyClassName="py-8"
      >
        <div className="flex items-center gap-3.5 bg-gray-200 rounded-lg px-6 py-5">
          <div className="flex items-center gap-1.75">
            <i className="-mt-0.5 ki-filled ki-information-1 text-2xl text-primary" />
            {/* <p className="font-semibold text-sm text-gray-700">
              {t('applyAppUpdate')}
            </p> */}
          </div>
          <Button
            text={t('forceAppUpdate')}
            buttonClassName="px-4 shadow-lg"
            textClassName="text-2sm"
            leftIcon={<i className="ki-outline ki-notification-on" />}
          />
        </div>
        {data && (
          <div className="mt-3 bg-gray-200 rounded-lg px-6 pt-4.5 pb-4 flex flex-col gap-1">
            <div className="flex items-center gap-[17px]">
              <i className="-mt-1 ki-outline ki-text-number text-primary text-lg" />
              <div className="text-gray-700 text-sm">
                <span className="font-medium">
                  {t('latestRequestNumber')} :{' '}
                </span>{' '}
                {`${data?.latestRequestNumber}`}
              </div>
            </div>
            <div className="flex items-center gap-[17px]">
              <i className="-mt-1 ki-outline ki-calendar text-primary text-lg" />
              <div className="text-gray-700 text-sm">
                <span className="font-medium">{t('common:lastUpdate')} : </span>{' '}
                {`${formatDateWithLetterMonth({
                  dateString: data?.updatedAt,
                  monthAbbreviated: false,
                })} ${t('common:at').toLowerCase()} ${getFormattedTime(
                  data?.updatedAt
                )}`}
              </div>
            </div>
          </div>
        )}
      </Card>
    </form>
  );
};
